import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { CaretLeft } from '@phosphor-icons/react';
import { Icon } from 'app/components';
import { LiveEvent } from '../../../../event-list/events/components';
import Organization from '../../../../event-list/organization/organization';
import { useSelector } from 'react-redux';
import {  Calendar, Plus } from '@phosphor-icons/react';
import { Banner } from "../../../../event-list/components";
import { useEffect } from 'react';
import { getEventList } from "../../../../event-list/api";

const OrganizersEdit = () => {
  const navigate = useNavigate();
  const params = useParams();

  const onClickBack = () => {
    navigate('/admin/primary/organizers');
  };

  const { eventList, eventsCount } = useSelector((state) => state.eventList);

  useEffect(() => {
      window.scrollTo(0, 0);
    }, []);

  const handleEdit = (eventId) => {
    navigate(`/event/edit/${eventId}`);
  };
  
  const handleView = (eventId) => {
    navigate(`/event/dashboard/${eventId}`);
  };

  useEffect(() => {
      getEventList({
        searchText: 'live' ,
        businessConfigId: params?.organizerId,
      });
    }, [params?.organizerId]);

  
  return (
    <div className='organizers-edit flex flex-col gap-14 p-8 overflow-auto'>
      <div className='flex items-center gap-4'>
        <Icon
          className="cursor-pointer"
          type="circle"
          onClick={onClickBack}
        >
          <CaretLeft
            color="#101010"
            size={16}
          />
        </Icon>
        <div className='label-16'>Organizers</div>
      </div>
      <Organization
        isAdmin={true}
        stateName="adminPrimaryOrganizersEdit"
        reducerPrefix="ADMIN_PRIMARY_ORGANIZERS_EDIT"
        organizerId={params?.organizerId}
      />
      <hr className='accent-grey-5 w-full my-0' />
      <div className='heading-24 pb-0'> Live events </div>
      {eventList?.length > 0 ? (<LiveEvent events={eventList} 
          handleEdit={handleView}
          handleView={handleView}
        />) : (<Banner icon={<Calendar size={32}/>} title = "No live events"/>)
      }
    </div>
  );
};

export default OrganizersEdit;
